import React from 'react';

import {
  LinearProgress,
} from '@material-ui/core';

import { 
  getPercent,
  fmtBigInteger,
  fmtPercent
} from '../../utils/formatters';



function getProgress(numerator, denominator) {
  return {
    objects: fmtBigInteger(numerator) + '/' + fmtBigInteger(denominator),
    percent: fmtPercent(numerator, denominator)
  };
}
  
function inputsCompleted(inputs) {
  return inputs.Rejected.Objects + inputs.Succeeded.Objects + inputs.Skipped.Objects + inputs.Failed.Objects;
}

export function fmtExecutionProgress(value) {
  
  if(!value) {
    return "";
  }
  const { objects, percent } = getProgress(inputsCompleted(value),value.Selected.Objects);

  const style = {
    display: 'flex',
    justifyContent: 'space-between'
  };
  
  return(
    <div>
      <div style={style}>
          <div style={{ fontSize: '.75rem' }}>{objects}</div>
          <div style={{ marginLeft: '8px'}}>{percent}</div>
      </div>
      <LinearProgress variant="determinate" value={getPercent(inputsCompleted(value), value.Selected.Objects)} />
    </div>
  );
}
